'use client';

import React__default, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { MobileDialogWrapper, MobileContent, MobileBody } from './MobileDialog.css.js';

var MobileDialog = function (props) {
    var children = props.children, _a = props.isShow, isShow = _a === void 0 ? false : _a, onUnmount = props.onUnmount;
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    useEffect(function () {
        if (!bodyNode) {
            return;
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isShow) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [bodyNode, isShow]);
    useEffect(function () {
        // Trigger onUnmount when component is un-mounted
        return function () {
            onUnmount && onUnmount();
        };
    }, [onUnmount]);
    if (!bodyNode || !isShow) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return createPortal(React__default.createElement(MobileDialogWrapper, { "data-cname": 'portal-mobile-dialog', isShow: isShow },
        React__default.createElement(MobileContent, null,
            React__default.createElement(MobileBody, null, children))), bodyNode);
};

export { MobileDialog as default };
//# sourceMappingURL=index.js.map
